import { view } from '@yola/ws-sdk';
import { BREAKPOINT_READ_CASCADE, DESKTOP_BREAKPOINT } from '../constants/breakpoints';

const getEffectiveResponsiveClassValue = ({
  element,
  className,
  breakpoint = null,
  skipOwnBreakpoint = false,
}) => {
  const cascade = BREAKPOINT_READ_CASCADE[breakpoint] || [DESKTOP_BREAKPOINT];
  const readOrder = skipOwnBreakpoint ? cascade.slice(1) : cascade;

  return readOrder.reduce(
    (found, breakpointInCascade) =>
      found ||
      view.accessors.getResponsiveClassValue({
        element,
        className,
        breakpoint: breakpointInCascade,
      })?.value ||
      null,
    null
  );
};

export default getEffectiveResponsiveClassValue;
